export const MODULE_USER = "Utilisateurs";
export const PATH_USER = "/utilisateurs";
export const TITLE_USER = "Liste des Utilisateurs";
export const ENDPOINT_GET_USER = "Users";

export const PATH_USER_N1 = "/utilisateurs/administrateurs/nationaux";
export const KEY_USER_N1 = "utilisateurs/administrateurs/nationaux";
export const TITLE_USER_N1 = "Liste des Administrateurs Nationaux";

export const PATH_USER_N1_SUP = "/utilisateurs/administrateurs/superviseurs";
export const KEY_USER_N1_SUP = "utilisateurs/administrateurs/superviseurs";
export const TITLE_USER_N1_SUP = "Liste des Superviseurs Nationaux ";

export const PATH_USER_N1_ADMIN = "/utilisateurs/administrateurs/admin_pays";
export const KEY_USER_N1_ADMIN = "utilisateurs/administrateurs/admin_pays";
export const TITLE_USER_N1_ADMIN = "Liste des Administrateurs Généraux";

export const PATH_USER_N2 = "/utilisateurs/administrateurs/regionaux";
export const KEY_USER_N2 = "utilisateurs/administrateurs/regionaux";
export const TITLE_USER_N2 = "Liste des Administrateurs Régionaux";

export const PATH_USER_N3 = "/utilisateurs/administrateurs/departementaux";
export const KEY_USER_N3 = "utilisateurs/administrateurs/departementaux";
export const TITLE_USER_N3 = "Liste des Administrateurs Départementaux";

export const PATH_USER_N4I = "/utilisateurs/identificateurs";
export const KEY_USER_N4I = "utilisateurs/identificateurs";
export const TITLE_USER_N4I = "Liste des Agents Identificateurs";

export const PATH_USER_N4INS = "/utilisateurs/inseminateurs";
export const KEY_USER_N4INS = "utilisateurs/inseminateurs";
export const TITLE_USER_N4INS = "Liste des Inseminateurs";

export const PATH_USER_N4R = "/utilisateurs/responsables_exploitation";
export const KEY_USER_N4R = "utilisateurs/responsables_exploitation";
export const TITLE_USER_N4R = "Liste des Responsables d'exploitation";

export const PATH_USER_N5E = "/utilisateurs/eleveurs";
export const KEY_USER_N5E = "utilisateurs/eleveurs";
export const TITLE_USER_N5E = "Liste des Eleveurs";

export const PATH_USER_N5P = "/utilisateurs/proprietaires";
export const KEY_USER_N5P = "utilisateurs/proprietaires";
export const TITLE_USER_N5P = "Liste des Propriétaire";

export const PATH_DETAIL_USER = "/utilisateurs/details";
export const KEY_DETAIL_USER = "utilisateurs/details";
export const TITLE_DETAIL_USER = "Détails de l'utilisateur";

export const PATH_SEARCH_USER = "/utilisateurs/search";
export const KEY_SEARCH_USER = "utilisateurs/search";
export const TITLE_SEARCH_USER = "Recherche";

export const MODULE_FERME = "Fermes";

export const PATH_FERME = "/donnees_ref/exploitations_publiques";
export const KEY_FERME = "donnees_ref/exploitations_publiques";
export const TITLE_FERME = "Liste des Fermes Publiques";

export const PATH_LOCAUX = "/donnees_ref/exploitation/locaux";
export const KEY_LOCAUX = "donnees_ref/exploitation/locaux";
export const TITLE_LOCAUX = "Liste des Fermes Privées";

export const MODULE_EXPLOITATION = "Exploitations";
export const PATH_EXPLOITATION_PUBLIC = "/donnees_ref/exploitations_publiques";
export const KEY_EXPLOITATION_PUBLIC = "donnees_ref/exploitations_publiques";
export const TITLE_EXPLOITATION_PUBLIC = "Liste des Fermes Publiques";

export const PATH_EXPLOITATION_PRIVEE = "/donnees_ref/exploitations_privees";
export const KEY_EXPLOITATION_PRIVEE = "donnees_ref/exploitations_privees";
export const TITLE_EXPLOITATION_PRIVEE = "Liste des Exploitations Privées";

export const MODULE_CAMPAGNE = "Campagnes";
export const PATH_CAMPAGNE = "/donnees_ref/operations";
export const KEY_CAMPAGNE = "donnees_ref/operations";
export const TITLE_CAMPAGNE = "Listes des operations";

export const MODULE_LOT = "Lots";
export const PATH_LOT = "/donnees_ref/exploitations/lots";
export const TITLE_LOT = "Liste des Lots";

export const PATH_LOGOUT = "/logout";

export const MODULE_LIEU = "Lieu";
export const PATH_LIEU = "/donnees_ref/lieu";
export const KEY_LIEU = "donnees_ref/lieu";
export const TITLE_LIEU = "Liste des Lieux";

export const MODULE_ANIMAL = "animals";

export const MODULE_DONNEE_REF = "DonneesReferences";
export const PATH_DONNEE_REF = "/donnees_ref";
export const TITLE_DONNEE_REF = "Données de Référence";

export const MODULE_ESPECE = "especes";
export const PATH_ESPECE = "/donnees_ref/espece";
export const TITLE_ESPECE = "Liste des Especes";

export const MODULE_ROLE = "Roles";
export const PATH_ROLE = "/donnees_ref/fonctions";
export const TITLE_ROLE = "Liste des Fonctions";

export const MODULE_PROFIL = "Profils";
export const KEY_PROFIL = "donnees_ref/profils";
export const PATH_PROFIL = "/donnees_ref/profils";
export const TITLE_PROFIL = "Liste des Profils";

export const MODULE_RACE = "Races";
export const PATH_RACE = "/donnees_ref/espece/race";
export const TITLE_RACE = "Liste des Races";
export const PATH_RACE_MENU = "/donnees_ref/race";

export const MODULE_PERMISSION = "Permissions";
export const PATH_PERMISSION = "/donnees_ref/permission";
export const TITLE_PERMISSION = "Liste des Permissions";

export const MODULE_IDENTIFICATION = "Identification";

export const MODULE_DASHBOARD = "Dashboard";
export const PATH_DASHBOARD = "/dashboard";
export const KEY_DASHBOARD = "dashboard";
export const TITLE_DASHBOARD = "Dashboard des Animaux Identifiés";

export const MODULE_DASHBOARD_ELEVAGE = "Animaux d'élevage";
export const PATH_DASHBOARD_ELEVAGE = "/dashboard/elevage";
export const KEY_DASHBOARD_ELEVAGE = "dashboard/elevage";
export const TITLE_DASHBOARD_ELEVAGE = "Animaux d'Elevage Identifiés";
export const TITLE_DASHBOARD_ELEVAGE_CIV = "Animaux d'élevage";

export const MODULE_DASHBOARD_COMPAGNIE = "Animaux de Compagnie";
export const PATH_DASHBOARD_COMPAGNIE = "/dashboard/compagnie";
export const TITLE_DASHBOARD_COMPAGNIE = "Animaux de Compagnie Identifiés";

export const MODULE_DASHBOARD_TRANSHUMANCE = "Animaux Transhumants";
export const PATH_DASHBOARD_TRANSHUMANCE = "/dashboard/transhumance";
export const TITLE_DASHBOARD_TRANSHUMANCE = "Animaux Transhumants Identifiés";

export const MODULE_DASHBOARD_ALERT = "Animaux en Alerte";
export const PATH_DASHBOARD_ALERT = "/dashboard/alerte";
export const TITLE_DASHBOARD_ALERT = "Animaux en Alerte Déclarée";

export const DEFAULT_PATH = PATH_DASHBOARD;

export const ENDPOINT_DASHBOARD_N1 =
  "animals/byDivisionLevel/codeLieu?division=NIVEAU_PAYS&codeLieu=";
export const ENDPOINT_DASHBOARD_N2 =
  "animals/byDivisionLevel/codeLieu?division=NIVEAU_REGION&codeLieu=";
export const ENDPOINT_DASHBOARD_N3 =
  "animals/byDivisionLevel/codeLieu?division=NIVEAU_DEPARTEMENT&codeLieu=";

export const ENDPOINT_DASHBOARD_FERME_N1 =
  "animals/byDivisionLevel/codeLieu/ferme?division=NIVEAU_PAYS&codeLieu=";
export const ENDPOINT_DASHBOARD_FERME_N2 =
  "animals/byDivisionLevel/codeLieu/ferme?division=NIVEAU_REGION&codeLieu=";
export const ENDPOINT_DASHBOARD_FERME_N3 =
  "animals/byDivisionLevel/codeLieu/ferme?division=NIVEAU_DEPARTEMENT&codeLieu=";

export const ENDPOINT_DASHBOARD_ALERT_N1 = "animals/dashboard/alert?division=NIVEAU_PAYS&codeLieu=";
export const ENDPOINT_DASHBOARD_ALERT_N2 =
  "animals/dashboard/alert?division=NIVEAU_REGION&codeLieu=";
export const ENDPOINT_DASHBOARD_ALERT_N3 =
  "animals/dashboard/alert?division=NIVEAU_DEPARTEMENT&codeLieu=";

export const MODULE_DASHBOARD_REPRODUCTION = "Animaux d'élevage";
export const PATH_DASHBOARD_REPRODUCTION = "/dashboard/insemination";
export const KEY_DASHBOARD_REPRODUCTION = "dashboard/insemination";
export const TITLE_DASHBOARD_REPRODUCTION = "Dashboard  Insemination";

export const ENDPOINT_DASHBOARD_REPRODUCTION_N1 =
  "Insemination/byDivisionLevel/codeLieu?division=NIVEAU_PAYS&codeLieu=";
export const ENDPOINT_DASHBOARD_REPRODUCTION_N2 =
  "Insemination/byDivisionLevel/codeLieu?division=NIVEAU_REGION&codeLieu=";
export const ENDPOINT_DASHBOARD_REPRODUCTION_N3 =
  "Insemination/byDivisionLevel/codeLieu?division=NIVEAU_DEPARTEMENT&codeLieu=";

export const MODULE_ENTITE = "Entite";
export const MODULE_ENTITE_TYPE = "Entite/type";

export const PATH_ENTITE_DETAIL = "/donnees_ref/entite/details";

export const PATH_DIRECTION = "/donnees_ref/directions";
export const KEY_DIRECTION = "donnees_ref/directions";
export const TITLE_DIRECTION = "Liste des Directions";

export const PATH_STRUCTURE_PRIVEE = "/donnees_ref/structures_privees";
export const KEY_STRUCTURE_PRIVEE = "donnees_ref/structures_privees";
export const TITLE_STRUCTURE_PRIVEE = "Liste des Structures Privées";

export const PATH_ORGANISATION_PUBLIC = "/donnees_ref/organisations_publiques";
export const KEY_ORGANISATION_PUBLIC = "donnees_ref/organisations_publiques";
export const TITLE_ORGANISATION_PUBLIC = "Liste des Organisations";

export const MODULE_TAG = "tags";
export const PATH_TAG = "/donnees_ref/projets";
export const KEY_TAG = "donnees_ref/projets";
export const TITLE_TAG = "Liste des Projets";

export const MODULE_ROBE = "robes";
export const PATH_ROBE = "/donnees_ref/robes";
export const KEY_ROBE = "donnees_ref/robes";
export const TITLE_ROBE = "Liste des robes";

export const MODULE_ANIMAUX = "animals";
export const PATH_ANIMAUX = "/donnees_ref/exploitations/animaux";
export const KEY_ANIMAUX = "donnees_ref/directions";
export const TITLE_ANIMAUX = "Liste des Animaux";

export const PATH_DETAIL_ANIMAL = "/animal/details";
export const TITLE_DETAIL_ANIMAL = "Détails de l'animal";

export const MODULE_DEMANDE_IDENTIFICATION = "demandes";
export const PATH_DEMANDE_IDENTIFICATION = "/animal/identification/demande";
export const KEY_DEMANDE_IDENTIFICATION = "animal/identification/demande";
export const TITLE_DEMANDE_IDENTIFICATION = "Liste des Demandes d'Identification";

export const PATH_DETAIL_DEMANDE_IDENTIFICATION = "/animal/identification/demande/details";

export const PATH_NEW_DEMANDE_IDENTIFICATION = "/animal/identification/demande/new";

// export const MODULE_IDENTIFICATION = "demande";
export const PATH_IDENTIFICATION = "/animal/identification";
export const KEY_IDENTIFICATION = "animal/identification";
export const TITLE_IDENTIFICATION = "Liste des Animaux Identifiés";
